import { batch, createComputed, untrack, type Accessor } from "solid-js"
import { useEntityGridXYMemo } from "../../../../rx/memo/useEntityGridXYMemo"
import useGridWidthHeight from "../../../../rx/memo/useGridWidthHeight"
import { useNodeNeighborIndexMap } from "../../../../rx/memo/useNodeNeighborIndexMap"
import { useTileCornerListSignal } from "../../../../rx/signal/useTileCornerListSignal"
import { useTileEdgeListSignal } from "../../../../rx/signal/useTileEdgeListSignal"
import { useTileNodeListSignal } from "../../../../rx/signal/useTileNodeListSignal"
import type { Engine } from "../Engine.type"
import createTileGraphCornerCollection from "../TileGraphCorner/createTileGraphCornerCollection"
import createTileGraphEdgeCollection from "../TileGraphEdge/createTileGraphEdgeCollection"
import createTileGraphNodeCollection from "./createTileGraphNodeCollection"
import type { TileGraphNode } from "./TileGraphNode.type"

export default function createTileGraphNodeCollectionMemo(engine: Engine): Accessor<Array<TileGraphNode>> {
  const gridSize = useGridWidthHeight(engine)
  const getNodeNeighborIndexMap = useNodeNeighborIndexMap(engine)
  const getEntityGridXY = useEntityGridXYMemo(engine)
  const [getNodeList, setNodeList] = useTileNodeListSignal(engine)
  const [, setEdgeList] = useTileEdgeListSignal(engine)
  const [, setCornerList] = useTileCornerListSignal(engine)
  createComputed(() => {
    const { width, height } = gridSize()

    const batchFn = untrack(() => {
      const neighborMap = getNodeNeighborIndexMap()
      const nodeList = createTileGraphNodeCollection(engine, neighborMap, getEntityGridXY, width, height)
      const edgeList = createTileGraphEdgeCollection(nodeList, width, height)
      const cornerList = createTileGraphCornerCollection(nodeList, width, height)
      // console.log('list = createTileGraphNodeCollection', list.length, list)
      const batchFn = () => {
        setNodeList(nodeList)
        setEdgeList(edgeList)
        setCornerList(cornerList)
      }
      return batchFn
    })
    batch(batchFn)
  })

  // createEffect(() => {
  //   gridSize()
  //   console.log('createTileGraphNodeCollectionMemo.gridSize.effect')
  // })

  // createEffect(() => {
  //   getNodeNeighborIndexMap()
  //   console.log('createTileGraphNodeCollectionMemo.getNodeNeighborIndexMap.effect')
  // })

  // createEffect(() => {
  //   getNodeNeighborIndexMap()
  //   console.log('createTileGraphNodeCollectionMemo.getNodeNeighborIndexMap.effect')
  // })

  // createEffect(() => {
  //   getList()
  //   console.log('createTileGraphNodeCollectionMemo.effect')
  // })

  return getNodeList
}
